import * as React from 'react'

import { SubMenu } from '../../../components/SubMenu/SubMenu'
import { Navigation } from './Navigation'

export default function Layout({ children }: React.PropsWithChildren) {
  return (
    <>
      <SubMenu leftContent={<Navigation />} />
      <div className="fv-container">{children}</div>
    </>
  )
}
